import type { PublicationSettlement } from '@affine/nbstore';
import type { LocalPublicationReceipt } from '@streamlain/doc-publication-contract';

import type { WorkspaceService } from '../../workspace';

/**
 * The remote end of the local publications of a writer that applies a
 * refused change again: on a refusal its documents are reopened from the
 * server state before the settlement returns.
 */
export interface PublicationSettlementPort {
  settle(
    receipt: LocalPublicationReceipt,
    signal?: AbortSignal
  ): Promise<PublicationSettlement>;
}

export function createPublicationSettlementPort(
  workspaceService: WorkspaceService
): PublicationSettlementPort {
  return {
    async settle(receipt, signal) {
      const { workspace } = workspaceService;
      const settled = await workspace.engine.doc.settlePublication(
        receipt,
        signal
      );
      if (settled.state === 'refused')
        for (const docId of settled.docIds)
          workspace.docCollection.reopenDoc(docId);
      return settled;
    },
  };
}
